<ng-container *ngIf="!navigationService.getRootPageUrl()">

    <ion-content padding class="bg">

        <!-- header -->
        <!-- <section>
            <p class="sec-title">Welcome to Aigens</p>
        </section>
        <ion-card class="bg-content aigens">
            <ion-card-header>
                <ion-card-title>Aigens Store</ion-card-title>
            </ion-card-header>
            <ion-button class="btn" href="https://demo-v2.order.place/store/5762589456859136/spot/1" replaceUrl="true"></ion-button>
        </ion-card>
        <ion-card class="bg-content foodcourt">
            <ion-card-header>
                <ion-card-title>Foodcourt</ion-card-title>
            </ion-card-header>
            <ion-button class="btn" href="https://dev.order.place/#/brand/5753217711341568" replaceUrl="true"></ion-button>
        </ion-card>
        <ion-card class="bg-content jp">
                <ion-card-header>
                        <ion-card-title>Japanese</ion-card-title>
                    </ion-card-header>
            <ion-button class="btn" href="https://dev.order.place/#/store/5706913572454400/spot/TEST" replaceUrl="true">
                
                
            </ion-button>
        </ion-card>
        <ion-card class="bg-content west">
                <ion-card-header>
                        <ion-card-title>Western</ion-card-title>
                    </ion-card-header>
            <ion-button class="btn" href="https://dev.order.place/#/store/5631457640841216/spot/TEST" replaceUrl="true">
                
            </ion-button>
        </ion-card>
        <ion-card class="bg-content fast">
                <ion-card-header>
                        <ion-card-title>Fastfood</ion-card-title>
                    </ion-card-header>
            <ion-button class="btn" href="https://demo.order.place/#/store/5630048086261760/spot/test" replaceUrl="true">
                
            </ion-button>
            
        </ion-card> -->

        <div class="main-error-box">
            <div class="error-header">
                <div class="header-img-box">
                    <img src="assets/images/404-text.svg">
                </div>
                <p class="header-text">Something went wrong.</p>
                <p class="header-text">Please try again.</p>
            </div>

            <div class="error-content">
                <div class="error-character img-box">
                    <img src="assets/images/404-burger.svg">
                </div>

                <div class="error-btn">
                    <p class="btn-try-again">Try Again</p>
                </div>
            </div>
        </div>


    </ion-content>
</ng-container>